import { createClient } from '@supabase/supabase-js';

// Use import.meta.env for Vite environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Provide a more informative error message
  console.error('Supabase URL or Anon Key is missing. Make sure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in your .env file and prefixed with VITE_');
  throw new Error('Supabase client failed to initialize: Missing environment variables.');
}

// Initialize and export the Supabase client
// Ensure that the Database type parameter matches your project's setup if you have generated types
// For now, we'll use the default <any>
export const supabase = createClient<any>(supabaseUrl, supabaseAnonKey);

// Optional: Add a check function or log to confirm initialization in development
if (import.meta.env.DEV) {
  console.log('Supabase client initialized with URL:', supabaseUrl);
  // Avoid logging the key itself, even the anon key, in logs.
} 